import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';

@Pipe({ name: 'requiredAsterisk', pure: true, standalone: false })
export class RequiredAsteriskPipe implements PipeTransform {
  transform(control: AbstractControl | null): boolean {
    if (!control) return false;
    return control.hasValidator(Validators.required);
  }
}
